import { render, staticRenderFns } from "./AreaList.vue?vue&type=template&id=56646fc8"
import script from "./AreaList.vue?vue&type=script&lang=js"
export * from "./AreaList.vue?vue&type=script&lang=js"
import style0 from "./AreaList.vue?vue&type=style&index=0&id=56646fc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports